import {
  BOARD_ACTIVE_TAB,
  CMMC_MODULE_ACTIVE_TAB,
  INSIDER_BOARD_ACTIVE_TAB, NIST171_MODULE_ACTIVE_TAB,
} from 'constants/ActionTypes';

const INIT_STATE = {
  boardActiveTab: 0,
  insiderBoardActiveTab: 0,
  cmmcModuleActiveTab: 0,
  nist171ModuleActiveTab: 0,
};

const misc = (state = INIT_STATE, action) => {
  switch (action.type) {

    case BOARD_ACTIVE_TAB:
      return {
        ...state,
        boardActiveTab: action.payload,
      };

    case INSIDER_BOARD_ACTIVE_TAB:
      return {
        ...state,
        insiderBoardActiveTab: action.payload,
      };

    case CMMC_MODULE_ACTIVE_TAB:
      return {
        ...state,
        cmmcModuleActiveTab: action.payload,
      };

    case NIST171_MODULE_ACTIVE_TAB:
      return {
        ...state,
        nist171ModuleActiveTab: action.payload,
      };

    default:
      return state;
  }
};

export default misc;
